module.exports = __webpack_public_path__ + "img/05_full.aee5341f.jpg";